export default "__VITE_ASSET__BL3o8u57__"